import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { mdiTagPlus } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setIsMediaTagInputActive } from 'store/mediaTags/actions/mediaTags.actions';
import { selectIsMediaTagInputActive } from 'store/mediaTags/selectors/mediaTags.selectors';
import { MediaTagInput } from './MediaTagInput/MediaTagInput';

// Same phone padding as the action buttons beside it in DialogActions.
const useStyles = makeStyles((theme) => ({
  addButton: {
    [theme.breakpoints.down('sm')]: {
      padding: 6,
    },
  },
}));

export const AddMediaTag = () => {
  const classes = useStyles();
  const isMediaTagInputActive = useSelector(selectIsMediaTagInputActive);

  const dispatch = useDispatch();

  const { t } = useTranslation('common');

  return (
    <div>
      {!isMediaTagInputActive ? (
        <IconButton
          className={classes.addButton}
          size="medium"
          onClick={() => dispatch(setIsMediaTagInputActive(true))}
        >
          <Icon path={mdiTagPlus} size={1}></Icon>
        </IconButton>
      ) : (
        <MediaTagInput></MediaTagInput>
      )}
    </div>
  );
};
